import React, { Fragment, useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button,Select,MenuItem } from '@mui/material/';
import InputLabel from '@mui/material/InputLabel';



import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import RepportBySector from '../../components/reports/list_secteur';
import Autorize from '../../components/ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Reports_Radier() {

    
    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState("false");

    const [dateDebut, setDateDebut] = useState("");
   
    const [dateDebutTmp, setDateDebutTmp] = useState("");
    const [reportname, setreportname] = useState("");
    
    const [clublist, setList] = useState("");
    
    const [value, setValue] = React.useState(new Date());
    const [selectedDate, handleDateChange] = useState(new Date());
    const handleChange = (newValue) => {
      setValue(newValue);
    };


  
    

    useEffect(() => {
      

      // console.log("LE CLUB est le : " + this.props.clubid)
      //setFormValue(clubid,this.props.clubid);
       //this.setState({clubid: this.props.clubid}); 
       //setDateDebutTmp(Date().getFullYear);
     //  handleDateChange(Date().getFullYear);
      //  setDateDebut(dateDebutTmp);


       }, [dateDebutTmp,reportname]);
       

   function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return year + "-" + month + "-" +day;
    }

    
    const handleChangeDebut = (newValue) => {
  
        console.log(formatDate(newValue));
       // setDateDebut(formatDate(newValue));
        setDateDebutTmp(formatDate(newValue));
        setDateDebut(formatDate(newValue));   
    };

    const handleChangeTypeRapport = (event) => {
          setreportname(event.target.value);
          setDateDebut(dateDebutTmp);
    };
    
    function StartRecherche()    
    {
        setDateDebut(dateDebutTmp);         
    }
        

      
      function mainHtml()
      {
  
          if(autorize)
          {
              return (<div>
                        <div style={{  width: '90%', margin: '3%' }}>
                    <Typography variant="h4" gutterBottom>
                      Rapports des membres radiés
                    </Typography>
                    <Grid container direction="row" >
                        <Grid item xs={1} container direction="row" > 
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'> 

                          
                            <DatePicker id="MyYear"                             
                                label="Pour quelle année"
                                inputFormat="YYYY"
                                views={['year']}
                                value={dateDebutTmp}
                                onChange={handleChangeDebut}
                                renderInput={(params) => <TextField {...params} />}
                                />

                            </LocalizationProvider>  
                            </Grid>

                            <Grid item xs={1} container direction="row" > 
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'> 

                          
                            <DatePicker id="MyMonth"                             
                                label="Pour quel mois"
                                inputFormat="MM"
                                views={['month']}
                                value={dateDebutTmp}
                                onChange={handleChangeDebut}
                                renderInput={(params) => <TextField {...params} />}
                                />

                            </LocalizationProvider>  
                            </Grid>
                
                            <Select
                                labelId="demo-simple-select-label"
                                id="selectReports"                               
                                label="Rapport"
                                onChange={handleChangeTypeRapport}
                            >
                                <MenuItem value="MembreRadierMois">Membres radiés par mois</MenuItem>
                                <MenuItem value="MembreAjouterMois">Membres ajoutés par mois</MenuItem>
                            
                            </Select>
                      
                            <Button onClick={StartRecherche} variant="containedFifth">Rechercher</Button>            
                    </Grid>
                              
                   


                    <RepportBySector key="sdsgdgdfadsad" annee={dateDebut}  reportname={reportname} />
                      

                  </div>

                      </div>);
          }
          else
              return "";
  
      }
    
      const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };


        return (

            <div>
                    <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>

                    {mainHtml()}
                    
                </div>
                 

            
        );
   
};

export default Reports_Radier;